import { IArticle } from '@/src/interfaces/generated/contentful';
import { JournalEntryGiftGuide } from '@/src/packages/components/pages/JournalEntry/JournalEntryGiftGuide';
import { JournalEntryNewsletterSignup } from '@/src/packages/components/pages/JournalEntry/JournalEntryNewsletterSignup';
import { Box } from '@/src/packages/components/ui/Box';
import { Container } from '@/src/packages/components/ui/Container';
import { RichText } from '@/src/packages/components/ui/RichText';
import { RichTextConfigArticle } from '@/src/packages/components/ui/RichText/RichText.config';

export const getListNodes = (article: IArticle) => {
  return (
    article.fields?.content?.content.filter(
      (node) => node.data?.target?.sys?.contentType?.sys?.id === 'list',
    ) || []
  );
};

const JournalEntryBody = ({ article }: { article: IArticle }) => {
  const lists = getListNodes(article);

  const isGuide = lists?.length > 0;

  return (
    <Box className="space-y-6">
      {isGuide ? (
        <JournalEntryGiftGuide article={article} />
      ) : (
        <Container className="mx-auto max-w-4xl">
          <RichText
            data={article.fields.content}
            options={RichTextConfigArticle}
          />
        </Container>
      )}

      <Box className="mx-auto max-w-3xl">
        <JournalEntryNewsletterSignup />
      </Box>
    </Box>
  );
};

export { JournalEntryBody };
